/*  useProductPageCms — thin wrapper over `useCms` that parses the JSON-
    string values (like `faq.items_json`, `hero.chips_json`, ...) with a
    fallback so a bad admin edit never blanks the live page.

    Usage:
      const { t, arr } = useProductPageCms("product_secure");
      const chips = arr("hero.chips_json", DEFAULT_CHIPS);
      const title = t("hero.title_line1", "Invisique Secure");

    Every hero/section/journey/etc. component that renders CMS-driven
    copy on the Guards & Retainer product pages consumes this hook.
*/
import { useCms } from "@/lib/useCms";


export function useProductPageCms(page) {
    const { t, cms, loading } = useCms(page);

    const arr = (key, fallback) => {
        const raw = t(key, null);
        if (!raw) return fallback;
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) && parsed.length ? parsed : fallback;
        } catch {
            return fallback;
        }
    };

    return { t, arr, cms, loading };
}
